import { render, staticRenderFns } from "./attribute-ranking-element-aside.component.vue?vue&type=template&id=5fcd8388&scoped=true"
import script from "./attribute-ranking-element-aside.component.vue?vue&type=script&lang=ts"
export * from "./attribute-ranking-element-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./attribute-ranking-element-aside.component.vue?vue&type=style&index=0&id=5fcd8388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd8388",
  null
  
)

export default component.exports